import React, { useState } from "react";

function FilterDialog({ photos, selectedPhotos, onApply, onCancel }) {
  const [previewFilter, setPreviewFilter] = useState("original");

  // helper: map filterApplied → CSS filter
  const getFilterStyle = (filter) => {
    switch (filter) {
      case "blackwhite":
        return "grayscale(100%)";
      case "sepia":
        return "sepia(100%)";
      case "original":
      default:
        return "none";
    }
  };

  // show only selected photos
  const selectedList = photos.filter((p) => selectedPhotos.includes(p.name));

  return (
    <div className="dialog-backdrop">
      <div className="dialog-box">
        <h3>Apply Filter</h3>
        <p>{selectedList.length} photo(s) selected</p>

        {/* ✅ Show previews of selected photos */}
        <div className="preview-row">
          {selectedList.map((photo) => (
            <img
              key={photo.name}
              src={photo.url}
              alt={photo.name}
              className="preview-thumb"
              style={{ filter: getFilterStyle(previewFilter) }}
            />
          ))}
        </div>

        {/* ✅ Filter buttons */}
        <div className="filter-options">
          <button
            className={previewFilter === "original" ? "active" : ""}
            onClick={() => setPreviewFilter("original")}
          >
            Original
          </button>
          &nbsp;
          <button
            className={previewFilter === "blackwhite" ? "active" : ""}
            onClick={() => setPreviewFilter("blackwhite")}
          >
            Black & White
          </button>
          &nbsp;
          <button
            className={previewFilter === "sepia" ? "active" : ""}
            onClick={() => setPreviewFilter("sepia")}
          >
            Sepia
          </button>
        </div>

        {/* ✅ Apply + Cancel */}
        <div className="dialog-actions">
          <button
            className="dialog-btn apply"
            onClick={() => onApply(previewFilter)}
          >
            Apply
          </button>
          <button className="dialog-btn cancel" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default FilterDialog;
